import styled, { css } from 'styled-components'

const Unread = styled.span`
    background: ${props => props.active ? '#FFF' : '#f84f7f'};
    font-size: 10px;
    border-radius: 50%;
    height: 22px;
    text-align: center;
    line-height: 22px;
    padding: 0px 6px;
    font-weight: 600;
    color: ${props => props.active ? '#f84f7f' : '#FFF'};;
    display: inline-block;
    margin-left: 5px;
    min-width: 22px;
`

const AccountActions = styled.div`
    display: flex;
    align-items: center;
`

const AccountAction = styled.div`
    background: var(--red);
    padding: 4px 8px;
    font-size: 11px;
    color: #FFF;
    font-weight: 600;
    border-radius: 3px;
    margin-right: 10px;
    &:hover {
        opacity: 0.7;
    }
`

const GetPremiumButton = styled(AccountAction)`
    font-size: 13px;
    background: linear-gradient(135deg, #ff5c93 0%, #ff4f8b 35%, #ff6fa8 70%, #e85db8 100%);
    border-radius: 5px;
    display: flex;
    align-items: center;
`

// AvatarModal's own wrapper is `position: absolute; z-index: 21`, which is sized
// by its nearest positioned ancestor — fine inside the Monetization panel, but
// from the sidebar it would land under the header (z-index 1000). This host
// gives it a viewport-sized, top-level box to fill.


const AccountMinutes = styled(AccountAction)`
    background: ${props => props?.lowMinutes ? 'var(--red)' : 'var(--green)'};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    svg {
        margin-right: 5px;
    }
`
const PremiumPopupContainer = styled.div`
    display: ${props => props?.isOpen ? 'block' : 'none'};
    position: absolute;
    width: 420px;
    background: #FFF;
    border-radius: 5px;
    right: 0px;
    box-shadow: 0px 0px 4px #8a8888;
    top: 30px;
    color: var(--text-gray);
    /* Typography the popup used to inherit from the AccountPremium button it
       was nested in — kept here now that it sits outside the button. */
    font-size: 11px;
    font-weight: 600;
    @media screen and (max-width: 678px) {
        width: 340px;
    }
    &:before {
        content: " ";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #e7e6e6;
        position: absolute;
        top: -10px;
        right: 20px;
    }
    &:after {
        content: " ";
        width: 100%;
        height: 20px;
        top: -10px;
        right: 0px;
        position: absolute;
    }
`

const AccountPremium = styled(AccountAction)`
    background: var(--blue);
    display: flex;
    align-items: center;
    cursor: pointer;
`

// Positioning context for PremiumPopupContainer, which is a sibling of the
// button rather than a child of it. Carries the button's trailing margin so the
// spacing in AccountActions stays the same.
const AccountPremiumWrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    ${AccountPremium} {
        margin-right: 0px;
    }
`

const CrownIcon = styled.span`
    display: inline-flex;
    align-items: center;
    svg {
        color: #FFF;
        width: 18px;
        height: 18px;
        margin-right: 3px;
    }
`

const balanceValue = css`
    grid-area: balance;
    white-space: nowrap;
    transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease;
`

const BalancePoints = styled.span`
    ${balanceValue}
`

const BalanceUsd = styled.span`
    ${balanceValue}
    transform: translateX(-115%);
    opacity: 0;
`

const BalanceSwap = styled.span`
    display: grid;
    grid-template-areas: 'balance';
    align-items: center;
    justify-items: center;
    /* clips whichever value is parked outside the pill */
    overflow: hidden;
`

const AccountBalance = styled(AccountAction)`
    background: transparent;
    border-radius: 3px 0px 0px 3px;
    color: var(--text-gray);
    border: 1px solid #c3c0c0;
    border-right: none;
    margin-right: 0px;
    padding: 1px 15px;

    /* On hover the points leave to the right while the dollars come in from the
       left; unhovering replays the same transitions backwards, right to left.
       Guarded on a real pointer so a tap can't leave a touch device stuck
       showing the converted amount. */
    @media (hover: hover) {
        &:hover ${BalancePoints} {
            transform: translateX(115%);
            opacity: 0;
        }

        &:hover ${BalanceUsd} {
            transform: translateX(0);
            opacity: 1;
        }
    }
`

const AccountTier = styled(AccountAction)`
    background: var(--yellow);
    padding: 2px 12px;
    border-radius: 0px 3px 3px 0px;
`

const AccountBonus = styled(AccountAction)`
    background: var(--yellow);
    padding: 2px 12px;
    position: relative;
`

const AccountGift =  styled(AccountAction)`
    background: var(--pink);
    @media screen and (min-width: 992px) {
        display: ${props => props.mobile ? 'none' : 'block' }
    }
`

const PremiumPopupHeader = styled.div`
    display: flex;
    padding: 10px 20px;
    border-bottom: 1px solid #edecee;
    align-items: center;
    ${CrownIcon} {
        background: var(--pink);
        width: 30px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        border-radius: 50%;
        svg {
            margin-right: 0px;
        }
    }
`

const PremiumPopupName = styled.div`
    flex: 1 1 auto;
    font-size: 14px;
    display: flex;
    align-items: center;
`

const PremiumPopupExpires = styled.div`
    font-size: 13px;
`

const PremiumPopupContent = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
`

const PremiumPopupBox = styled.div`
    background: #fdf2f6;
    border-radius: 10px;
    border: 1px solid #f9dce7;
    padding: 20px;
    width: 48%;
`



const PremiumIcon = styled.div`
    width: 50px;
    height: 50px;
    background: #fde8ef;
    border-radius: 50%;
    color: var(--pink);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin: 0 auto;
`

const PremiumPopupAmount = styled.div`
    text-align: center;
    font-weight: 600;
    font-size: 30px;
    color: var(--pink);
`

const PremiumPopupKind = styled.div`
    text-align: center;
    font-size: 13px;
`

const PremiumPopupDesc = styled.div`
    text-align: center;
    margin-top: 10px;
    border-top: 1px solid #e1dce0;
    padding-top: 10px;
`
const PremiumQuestion = styled.span`
    color: var(--blue)
`

const PremiumPopupAction = styled.div`
    background: var(--green);
    padding: 8px 0px;
    display: block;
    color: #FFF;
    border-radius: 3px;
    &:hover {
        opacity: 0.7;
    }
`

const ListMenuDesktop = styled.div`
    display: flex;
    @media screen and (max-width: 992px) {
        display: none;
    }
`

const ListMenuMobile = styled.div`
    display: flex;
    @media screen and (min-width: 992px) {
        display: none;
    }
`

const ListMenuItem = styled.div`
    color: ${props => props.active ? 'var(--pink)' : '#182338'};
    padding: 12px 15px;
    font-size: 18px;
    width: 52px;
    cursor: pointer;
    position: relative;
    text-align: center;
    &:hover {
        opacity: 0.7;
        color: var(--pink);
    }
    @media screen and (max-width: 678px) {
        display: ${props => props.isMobileHide ? 'none' : 'block'};
    }
`

const UnreadMobile = styled(Unread)`
    position: absolute;
    top: 5px;
    right: 3px;
    border-radius: 4px;
    height: 18px;
    min-width: 18px;
    line-height: 18px;
`

const Count = styled.span`
    background: #e62424;
    padding: 0px 5px;
    border-radius: 5px;
    position: absolute;
    top: 0px;
    right: -7px;
    font-weight: 500;
    font-size: 11px;
`

const AvatarContainer = styled.div`
    box-shadow: 0px 0px 7px ${props => props.active ? 'var(--green)' : '#d91d1d'} !important;
    position: relative;
`

const CallPointsStatus = styled.span`
    width: 12px;
    height: 12px;
    display: inline-block;
    background: ${props => props.active ? 'var(--yellow)' : '#d91d1d'};
    border-radius: 50%;
    position: absolute;
    bottom: -6px;
    right: -5px;
`

const UserDropdownContainer = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: #FFF;
    width: 320px;
    box-shadow: 0px 0px 4px #8a8888;
    border-radius: 5px;
    z-index: 1000;
    // display: none;
`

const StatusContainer = styled.div`
    padding: 15px 20px;
    font-size: 14px;
`

const StatusModalContent = styled.div`
    padding: 20px 20px 16px;

    @media screen and (max-width: 575px) {
        padding: 18px 16px 14px;
    }
`

const StatusChange = styled.div`
    color: var(--pink);
`

const ProfileContainer = styled.div`
    padding: 15px 20px;
    font-size: 14px;
    border-top: 2px solid #f0f0f0;
    position: relative;
    display: flex;
    align-items: center;
    svg {
        margin-right: 10px;
    }
`

const StatusTitle = styled.h3`
    font-weight: 600;
    font-size: 16px;
    line-height: 1.2;
    margin: 0 0 14px;
    color: #1f2533;
`

const StatusList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const StatusCard = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 13px;
    border-radius: 11px;
    border: 1.5px solid ${props => props.selected ? 'var(--pink)' : '#e8e9ed'};
    background: ${props => props.selected ? '#fff6f9' : '#fff'};
    cursor: pointer;
    user-select: none;
    transition: border-color .16s ease, background .16s ease;

    &:hover {
        border-color: ${props => props.selected ? 'var(--pink)' : '#f1c2d2'};
        background: ${props => props.selected ? '#fff6f9' : '#fcfcfd'};
    }

    &:focus-visible {
        outline: none;
        border-color: var(--pink);
        box-shadow: 0 0 0 3px rgba(248, 79, 127, 0.16);
    }
`

const StatusInfo = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`

const StatusAction = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    font-weight: 600;
    font-size: 14px;
    color: #1f2533;
`

const Status = styled.span`
    width: 8px;
    height: 8px;
    flex: 0 0 auto;
    display: inline-block;
    background: ${props => props.active ? 'var(--green)' : '#d91d1d'};
    border-radius: 50%;
`

const StatusDesc = styled.div`
    font-size: 12px;
    color: var(--gray);
    margin-top: 2px;
    line-height: 1.3;
`

const StatusRadioIndicator = styled.div`
    flex: 0 0 auto;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    border: 2px solid ${props => props.selected ? 'var(--pink)' : '#d2d5dc'};
    background: ${props => props.selected ? 'var(--pink)' : '#fff'};
    position: relative;
    transition: border-color .16s ease, background .16s ease;

    &::after {
        content: '';
        position: absolute;
        display: ${props => props.selected ? 'block' : 'none'};
        left: 6px;
        top: 2px;
        width: 4px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`

const StatusActionContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
`

const Action = styled.button`
    flex: 1 1 0;
    min-height: 40px;
    border: 1px solid var(--pink);
    background: var(--pink);
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    padding: 10px 0;
    border-radius: 9px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    transition: opacity .16s ease, background .16s ease;

    svg {
        width: 16px;
        height: 16px;
    }

    &:hover:not(:disabled) {
        opacity: 0.9;
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(248, 79, 127, 0.3);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }
`

const ActionClose = styled(Action)`
    border: 1px solid #dcdee3;
    background: #fff;
    color: var(--gray);

    &:hover:not(:disabled) {
        opacity: 1;
        background: #f6f6f7;
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
    }
`

const CallPoints = styled.span`
    font-size: 12px;
    font-weight: 500;
    padding: 2px 5px;
    display: inline-block;
    background: ${props => props.active ? 'var(--green)' : '#d91d1d'};
    color: #FFF;
    border-radius: 3px;
    position: absolute;
    right: 10px;
    top: 15px;
`

const PremiumPopupMinutesBox = styled(PremiumPopupBox)`
    background: #f4f9f6;
    border-color: #dfeae3;
    ${PremiumPopupAmount} {
        color: var(--green);
    }
    ${PremiumIcon} {
        color: var(--green);
        background: #e4f1e6;
    }
`

export {
    Unread,
    AccountActions,
    AccountAction,
    AccountMinutes,
    AccountPremium,
    AccountPremiumWrapper,
    PremiumPopupContainer,
    PremiumPopupHeader,
    PremiumPopupName,
    PremiumPopupExpires,
    PremiumPopupContent,
    PremiumPopupBox,
    PremiumPopupAmount,
    PremiumPopupKind,
    PremiumPopupDesc,
    PremiumQuestion,
    PremiumPopupAction,
    ListMenuDesktop,
    ListMenuMobile,
    ListMenuItem,
    AccountBonus,
    AccountTier,
    AccountBalance,
    BalanceSwap,
    BalancePoints,
    BalanceUsd,
    UnreadMobile,
    Count,
    CallPointsStatus,
    AvatarContainer,
    AccountGift,
    UserDropdownContainer,
    StatusContainer,
    StatusChange,
    Status, ProfileContainer, StatusTitle, StatusList,
    StatusCard, StatusInfo, StatusRadioIndicator,
    StatusDesc, StatusAction, StatusModalContent,
    StatusActionContainer, Action, ActionClose, CallPoints, CrownIcon,
    PremiumIcon, PremiumPopupMinutesBox, GetPremiumButton,
}